import React, { useState } from 'react';
import { BrowserRouter } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import HomeSlider from './components/HomeSlider';
// import Login2 from './components/Login2';
import RegisterPopup from './components/RegisterPopup'; // Make sure this path is correct
import FeaturesArNXT from './components/FeaturesArNXT';

function App() {
  const [openRegister, setOpenRegister] = useState(false);

  return (
    <BrowserRouter>
      <div>
        <Navbar onGetStartedClick={() => setOpenRegister(true)} />
        {/* <Login2 /> */}
         <HomeSlider
  setOpenLogin={() => setOpenRegister(true)}
  setToggleForm={() => {}}
/>
<FeaturesArNXT/>
        <RegisterPopup open={openRegister} handleClose={() => setOpenRegister(false)} />
      </div>
    </BrowserRouter>
  );  
}

export default App;
